module.exports = __webpack_public_path__ + "img/jsb-down-bg.png.0c34afd4.png";